import { render, staticRenderFns } from "./Apartment.vue?vue&type=template&id=10b5f270&scoped=true"
import script from "./Apartment.vue?vue&type=script&lang=js"
export * from "./Apartment.vue?vue&type=script&lang=js"
import style0 from "./Apartment.vue?vue&type=style&index=0&id=10b5f270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b5f270",
  null
  
)

export default component.exports